import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/Operators";
import { Observable, throwError, Subject } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { MsAdalAngular6Service } from "microsoft-adal-angular6";
import { Router, ActivatedRoute } from "@angular/router";
import { LocalStorageService } from "./local-storage.service";
import { ApplicationPageDetails } from "../models/application-page-details.interface";
import { isNullOrUndefined } from "util";
import { AppConfig } from "../../app.config";
import { Userinfo } from "../../../Models/Userinfo";
import { EmployeeService } from "../../shared/service/employee.service";
import { TokenService } from "./token.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  mobileAPIURL: string;
  public userInfo: Userinfo;
  pageAcessDetils: ApplicationPageDetails[];
  QuestionList: any;
  isPMFlag = false;
  alertMsg = "Please click OK to confirm...";
  offboardingId: number;
  public IsManageView = new Subject<any>();
  constructor(
    private http: HttpClient,
    private adalSvc: MsAdalAngular6Service,
    private _router: Router,
    private _localStorage: LocalStorageService,
    private config: AppConfig,
    private router: Router,
    private empsvc: EmployeeService,
    private route: ActivatedRoute,
    private tokenService: TokenService
  ) {
    this.mobileAPIURL = this.config.apiUrl + "HREmployeeApi/";
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }

  public isUserObjectExists() {
    if (this.userInfo == null || this.userInfo == undefined) {
      return false;
    } else return true;
  }

  clearStorage() {
    this._localStorage.removeItem("empcode");

    this._localStorage.removeItem("applicationPageDetails");
    this._localStorage.removeItem("doJ");

    this._localStorage.removeItem("fullName");
    this._localStorage.removeItem("email");
  }

  allClearStorage() {
    this._localStorage.removeAll();
  }

  setUserDetails(offboardingId) {
    this.getUserInformation().subscribe((userInfo: Userinfo) => {
      this.tokenService.saveToken(userInfo.Token || "");
      this.userInfo = userInfo;
      this._localStorage.setItem(
        "applicationMenu",
        JSON.stringify(this.userInfo.menu)
      );
      if (offboardingId) {
        this.empsvc
          .getOffboardingDetailsById(offboardingId)
          .subscribe((data: any) => {
            const finalData = data;
            this._localStorage.setItem(
              "getOffboardingDetailsById",
              JSON.stringify(finalData)
            );
            // if (finalData != null && finalData.EmpCode == userInfo.EmpCode) {
            //   window.location.href =
            //     "https://qa-winemployee.azurewebsites.net/" +
            //     "myprofile/" +
            //     userInfo.EmpCode;
            // } else {
            //   window.location.href =
            //     "https://qa-winhr.azurewebsites.net/" +
            //     "Offboardinglist/tabIndex/0";
            // }
          });
      }
      this.empsvc.getOffboardingClearanceList().subscribe(
        (data: any) => {
          this._localStorage.setItem("LWDDetails", JSON.stringify(data));
        },
        (error) => {}
      );
      this.empsvc.getDateofExitByEmpCode(userInfo.EmpCode).subscribe(
        (empDetails: any) => {
          if (empDetails) {
            this._localStorage.setItem(
              "ExitDate",
              empDetails
            );
          } else {
            this._localStorage.removeItem("ExitDate");
          }
        },
        (error) => { }
      );

      this.clearStorage();
      this._localStorage.setItem(
        "fullName",
        userInfo.NamePerRecords.toString()
      );
      this.clearStorage();
      this._localStorage.setItem(
        "fullName",
        userInfo.NamePerRecords.toString()
      );
      this._localStorage.setItem("empcode", userInfo.EmpCode.toString());
      this._localStorage.setItem("email", userInfo.Email.toString());
      this._localStorage.setItem(
        "designation",
        userInfo.DesignationName.toString()
      );
      this._localStorage.setItem("department", userInfo.Department.toString());
      this._localStorage.setItem("doJ", userInfo.DOJ.toString());

      this._localStorage.setItem(
        "applicationPageDetails",
        JSON.stringify(this.userInfo.permissions)
      );

      this.getApplicationDetails();
    });
  }

  getUserInfoLS() {
    var obj = this._localStorage.getItem("userInfo");
    if (!!obj) return JSON.parse(obj.replace(/\\/g, ""));
  }

  getLWDDetails() {
    var obj = this._localStorage.getItem("LWDDetails");
    if (!!obj) return JSON.parse(obj.replace(/\\/g, ""));
  }

  getOffboardingDetailsByIdData() {
    var obj = this._localStorage.getItem("getOffboardingDetailsById");
    if (!!obj) return JSON.parse(obj.replace(/\\/g, ""));
  }

  getExitDate() {
    return this._localStorage.getItem("ExitDate");
  }

  getApplicationDetails() {
    this.userInfo = new Userinfo();
    var obj = this._localStorage.getItem("applicationPageDetails");
    if (!!obj) this.userInfo.permissions = JSON.parse(obj.replace(/\\/g, ""));
    return this.userInfo.permissions;
  }
  applicationMenu() {
    var obj = this._localStorage.getItem("applicationMenu");
    if (!!obj) return JSON.parse(obj.replace(/\\/g, ""));
  }
  getEmail() {
    return this._localStorage.getItem("email");
  }
  getFullName() {
    return this._localStorage.getItem("fullName");
  }
  getdOJ() {
    return this._localStorage.getItem("doJ");
  }

  getEmpCode() {
    if (!!this._localStorage.getItem("empcode"))
      return Number(this._localStorage.getItem("empcode"));
    return 0;
  }
  getPeopleManagerEmpCode() {
    return Number(this._localStorage.getItem("peoplemanagerempcode"));
  }
  getRole() {
    return this._localStorage.getItem("roles");
  }
  getFY() {
    return this._localStorage.getItem("FY");
  }
  getUserInformation() {
    return this.http
      .get(
        this.mobileAPIURL +
          "GetWinHRUserPermissions?emailId=" +
          this.adalSvc.LoggedInUserEmail
      )
      .pipe(catchError(this.handleError));
  }

  getJWTToken() {
    if (this.adalSvc.LoggedInUserEmail) {
      return this.http
        .get(
          this.config.apiUrl +
            "OnboardingApi/GetJWTToken?slug=" +
            this.adalSvc.LoggedInUserEmail
        )
        .pipe(catchError(this.handleError));
    }
  }

  getEmployeeUserInformation(email) {
    return this.http
      .get(this.mobileAPIURL + "GetWinHRUserPermissions?emailId=" + email)
      .pipe(catchError(this.handleError));
  }

  getDepartment() {
    return this._localStorage.getItem("department");
  }
  getDesignation() {
    return this._localStorage.getItem("designation");
  }
  getHasAccess() {
    return Boolean(this._localStorage.getItem("HasFullAccess"));
  }
  checkPageIsFound(pageName) {
    this.getApplicationDetails();
    //this.pageAcessDetils = Jsothis._localStorage.getItem("applicationPageDetails");
    if (
      !!this.userInfo &&
      !!this.userInfo.permissions &&
      this.userInfo.permissions.length > 0
    ) {
      let obj = this.userInfo.permissions.filter((c) => c.URL == pageName);
      if (obj != null && obj.length > 0) {
        return true;
      }
    }
    return false;
  }
  checkPageAccess(pageName) {
    // this.pageAcessDetils = this._localStorage.getItem("applicationPageAccessDetails");
    let checkObj: any;
    this.getApplicationDetails();
    if (pageName.search("/myprofile") != -1) {
      return true;
    }
    if (pageName.search("/offboardingfeedback") != -1) {
      return true;
    }
    if (pageName.search("/OffboardingSettings") != -1) {
      return true;
    }
    checkObj = this.userInfo.permissions.filter(
      (x) => x.Menu == "Offboarding"
    )[0];
    if (!isNullOrUndefined(checkObj)) {
      if (pageName.search("Offboardinglist") != -1) {
        return true;
      }
    }
    if (
      !!this.userInfo &&
      !!this.userInfo.permissions &&
      this.userInfo.permissions.length > 0
    ) {
      let obj = this.userInfo.permissions.filter((c) => c.URL == pageName);
      if (obj != null && obj.length > 0) {
        this._localStorage.setItem(
          "HasFullAccess",
          obj[0].HasFullAccess.toString()
        );
        return true;
      }
      checkObj = this.userInfo.permissions.filter((x) => x.Menu == "Master")[0];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/hremployeedetails") != -1) return true;
      }
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/employeehistory") != -1) return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Onboarding"
      )[0];
      if (!isNullOrUndefined(checkObj)) {
        if (
          pageName.search("/onboardingdetails") != -1 ||
          pageName.search("/EmployeeVerification") != -1
        )
          return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Permissions"
      )[0];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/addpermissions") != -1) return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Holidays"
      )[0];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/holidaylistdetails") != -1) return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Offboarding"
      )[0];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/offboardingdetails") != -1) return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Offboarding"
      )[1];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/OffboardingSettings") != -1) return true;
      }
      checkObj = this.userInfo.permissions.filter(
        (x) => x.Menu == "Insurance"
      )[0];
      if (!isNullOrUndefined(checkObj)) {
        if (pageName.search("/sumAssuredDetails") != -1) return true;
      }
    }
    return false;
  }

  setDropdownValues(obj, cat, isManger): any {
    let QuestionList = this.QuestionList.filter(function (item) {
      return item.GroupCategory == cat;
    });
    for (var i = 0; obj.length > i; i++) {
      var value = QuestionList.find((c) => c.QuestionText == obj[i].Question);
      if (!!value) {
        if (isManger) obj[i].AnswerType = value.ManagerAnswerType;
        else obj[i].AnswerType = value.AnswerType;
      }
    }
    return obj;
  }
  getQustionAnswerValues(type: number): any {
    switch (type) {
      case 1:
        return ["Yes", "No"];
        break;
      case 2:
        return ["Always", "Mostly", "Sometimes", "Never"];
        break;
      case 3:
        return ["Agree", "Disagree"];
        break;
      default:
        return [
          "Yes",
          "No",
          "Always",
          "Mostly",
          "Sometimes",
          "Never",
          "Agree",
          "Disagree",
        ];
    }
  }
  getProjectName(code: any, collection: any) {
    if (!!collection) {
      var projectDetails = collection[code];
      return projectDetails;
    }
    return null;
  }
  transform(collection: any, property: string): any {
    // prevents the application from breaking if the array of objects doesn't exist yet
    if (!collection) {
      return null;
    }

    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }

      return previous;
    }, {});

    // this will return an array of objects, each object containing a group of objects
    return groupedCollection; //Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
  }
}
